import React from "react";
import SEO from "../Components/SEO";
import Card2 from "../Images/Headers/trainings.jpg";
import "../Pages/OurHistory.css";
import Breadcrumb from "react-bootstrap/Breadcrumb";
import "../Pages/NewsandEvents.css"; // ← reuse styles for hero and breadcrumb

function CapacityBuilding() {
  return (
    <div className="ne-page">
      <SEO
        title="Capacity Building"
        description="At CIRCODU, we understand that sustainable change doesn't just come from research and policy; it comes from people. That's why we have expanded our work to include community-based training programs that put knowledge, skills, and opportunity directly into the hands of those who need it most."
        keywords="capacity building, community training programs, sustainable development, clean energy solutions, bio-briquette production, self-sufficiency, environmental stewardship, economic resilience, CIRCODU, capacity building Uganda, community training Uganda, sustainable development training Uganda, clean energy training Uganda, bio-briquette training Uganda"
        url="/our-services/capacity-building"
        type="website"
      />

      {/* Hero */}
      <div className="ne-hero">
        <div className="ne-hero__image">
          <img src={Card2} alt="News and Events Header" />
        </div>
        <div className="ne-hero__overlay">
          <h4 className="ne-hero__title">Capacity Building</h4>
          <Breadcrumb>
            <Breadcrumb.Item className="text1" href="/">
              Home
            </Breadcrumb.Item>
            <Breadcrumb.Item className="text1">Our Services</Breadcrumb.Item>
            <Breadcrumb.Item className="text1">
              Capacity Building
            </Breadcrumb.Item>
          </Breadcrumb>
        </div>
      </div>

      <section className="section border-bottom">
        <div className="container border-top">
          <div className="row">
            <div className="col-md-12 mt-2">
              {/* Intro */}
              <h5 style={{ color: "#008250", fontSize: "16px" }}>
                <b>Capacity Building</b>
              </h5>
              <p className="texty">
                At CIRCODU, we understand that sustainable change doesn't just
                come from research and policy; it comes from people. That's why
                we have expanded our work to include{" "}
                <b>community-based training programs</b> that put knowledge,
                skills, and opportunity directly into the hands of those who
                need it most.
              </p>

              {/* Community Training Initiatives */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🏠 Community Training Initiatives</b>
              </h5>
              <p className="texty">
                Our capacity-building programs are designed with one goal in
                mind: to empower individuals and communities to become{" "}
                <b>active agents of sustainable development</b>. We equip
                participants with the practical skills to create alternative,
                environmentally friendly energy sources for both everyday
                cooking and income generation.
              </p>
              <p className="texty">
                A flagship example of this is our training in the{" "}
                <b>production of bio-briquettes,</b> an affordable, clean, and
                renewable fuel alternative that reduces dependence on charcoal
                and wood, cuts harmful emissions, and opens up new economic
                opportunities for community members.
              </p>

              {/* What We Build */}
              <h5 style={{ color: "#008250", fontSize: "14px" }}>
                <b>🏆 What We Build</b>
              </h5>
              <p className="texty">
                Beyond technical skills, our training programs build:
              </p>
              <ul className="texty">
                <li className="mt-2">
                  <b>Self-sufficiency</b> — Communities that can produce and
                  manage their own clean energy solutions
                </li>
                <li className="mt-2">
                  <b>Environmental stewardship</b> — Individuals who understand
                  and champion eco-friendly practices
                </li>
                <li className="mt-2">
                  <b>Economic resilience</b> — New income streams through the
                  production and sale of clean energy products
                </li>
              </ul>

              <hr />

              {/* Closing statement */}
              <p className="texty">
                <i>
                  Because the most powerful investment we can make is in the
                  people who will carry this mission forward.
                </i>
              </p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default CapacityBuilding;
